<!-- Title -->
<app-title class="d-print-none" />

<!-- Content -->
<main>
  <router-outlet />
</main>

<!-- Footer -->
<footer class="d-print-none">
  <app-footer />
</footer>